<template>
  <v-card flat class="mx-2">
    <v-card-title class="pb-0">{{ $t("registroActividad.subtitle") }}</v-card-title>
    <v-card-text class="pt-0 mt-0">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <user-autocomplete
            v-model="filters[0].value"
            :label="$t('registroActividad.filters.usuario')"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="filters[1].value"
            :label="$t('registroActividad.filters.accion')"
            :items="actionItems"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="filters[2].value"
            :label="$t('registroActividad.filters.entidad')"
            :items="entityItems"
            :loading="loadingEntities"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <date-input
            v-model="filters[3].value"
            :label="$t('registroActividad.filters.desde')"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <date-input
            v-model="filters[4].value"
            :label="$t('registroActividad.filters.hasta')"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn small text color="secondary" @click="cleanFilters">
            {{ $t("common.clearFilters") }}
          </v-btn>
          <v-btn small color="secondary" @click="setFilters">
            {{ $t("common.applyFilters") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { DateInput } from "@dracul/dayjs-frontend";
import { UserAutocomplete } from "@dracul/user-frontend";
import RegistroActividadProvider from "../../providers/RegistroActividadProvider";

export default {
  name: "RegistroActividadFilters",
  components: { DateInput, UserAutocomplete },
  props: {
    value: Array,
  },
  data() {
    return {
      entities: [],
      loadingEntities: false,
    };
  },
  computed: {
    entityItems() {
      return this.entities.map((e) => {
        let text = e;
        if (e === "Tamanio") text = "Tamaño";
        else if (e === "OrdenVenta") text = "Orden de venta";
        else if (e === "OrdenCompra") text = "Orden de Compra";
        return { text, value: e };
      });
    },
    filters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    actionItems() {
      return [
        { text: this.$t("registroActividad.actions.CREATE"), value: "CREATE" },
        { text: this.$t("registroActividad.actions.UPDATE"), value: "UPDATE" },
        { text: this.$t("registroActividad.actions.UPDATE_MANY"), value: "UPDATE_MANY" },
        { text: this.$t("registroActividad.actions.DELETE"), value: "DELETE" },
      ];
    },
  },
  mounted() {
    this.cargarEntidades();
  },
  methods: {
    async cargarEntidades() {
      this.loadingEntities = true;
      try {
        const r = await RegistroActividadProvider.entities();
        this.entities = r.data.registroActividadEntities || [];
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingEntities = false;
      }
    },
    setFilters() {
      this.$emit("updateFilters", this.filters);
    },
    cleanFilters() {
      this.$emit("clearFilter", this.filters);
    },
  },
};
</script>
